import CustomButton from 'components/Buttons/CustomButton'
import { useEffect, useState } from 'react'
import { AlertCircle } from 'react-feather'
import { useDispatch } from 'react-redux'
import { FormGroup, Input, Label, Modal, ModalBody } from 'reactstrap'
import { editLotId } from '../../API/manageStockAction'
import { enqueueSnackbar } from 'notistack'

export default function ModalEditLotId({ isOpen, onClose, data, setIsFetch }) {
  const dispatch = useDispatch()
  const [label, setLabel] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSubmit = async () => {
    setLoading(true)
    try {
      const obj = {
        prevLotCode: data?.lots[0]?.data?.lotCode,
        newLotCode: label,
      }
      const res = await dispatch(editLotId(obj))
      if (res?.error) {
        throw res
      } else {
        setIsFetch('inventory')
        onClose()
        enqueueSnackbar(`Lot ID berhasil diubah.`, {
          variant: 'success',
        })
      }
    } catch (error) {
      enqueueSnackbar(error?.message ?? error?.payload, {
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (isOpen) {
      //
    } else {
      setLabel('')
    }
  }, [isOpen])

  return (
    <Modal className="p-4" isOpen={isOpen} toggle={onClose} centered>
      <ModalBody>
        <h5>Edit Lot ID</h5>
        <div className="mb-2">
          <span>
            Perubahan akan meliputi semua inventory dengan Lot ID yang sama.
          </span>
        </div>
        <FormGroup>
          <Label>Lot ID</Label>
          <Input
            name="label"
            id="label"
            autoFocus={true}
            value={label ?? ''}
            onChange={(e) => {
              setLabel(e.target.value)
            }}
            placeholder="Lot ID"
          />
        </FormGroup>

        <div className="d-flex gap-3">
          <CustomButton
            onClick={() => {
              onClose()
            }}
            disabled={loading}
            color="primary"
            outline
            block
            className="btn-cancel"
          >
            Batal
          </CustomButton>
          <CustomButton
            disabled={loading ?? !label}
            onClick={handleSubmit}
            color="primary"
            block
          >
            Ubah
          </CustomButton>
        </div>
      </ModalBody>
    </Modal>
  )
}
